module.exports = __webpack_public_path__ + "img/Bodice-Back-Jb-Kf-La.dbd00be1.png";